'use strict';

window.addEventListener('DOMContentLoaded', () => {
  const timelineItem = document.querySelector('.p-timeline__item');
  const headerDom = document.querySelector('.l-header')!;

  function setCssProperty() {
    /* company Page */
    if (timelineItem != null) {
      const timelineWidth = timelineItem?.clientWidth.toString();
      document.documentElement.style.setProperty(
        '--timelineWidth',
        ''.concat(timelineWidth, 'px')
      );
    }

    // headerの高さを取得
    const headerDomHeight = headerDom.clientHeight.toString();
    document.documentElement.style.setProperty(
      '--headerHeight',
      ''.concat(headerDomHeight, 'px')
    );
  }
  setCssProperty();
  window.addEventListener('resize', setCssProperty);

  // button hover
  const ctaButton = document.querySelector('.p-corporation__ctaButton')!;
  const ctaText = document.querySelector(
    '.p-corporation__ctaText'
  ) as HTMLElement;

  ctaButton.addEventListener('mouseenter', () => {
    ctaText.style.color = 'var(--green-secondary)';
  });
  ctaButton.addEventListener('mouseleave', () => {
    ctaText.style.color = 'var(--green)';
  });
});
